import React, {Component} from 'react';
import ZkModal from "../../../common/modal/zkModal";
import {RedoOutlined} from "@ant-design/icons";
import {Button, Input} from "antd";
import imWarning from "../../image/chat/imWarning.png";
import CloudApi from "../../../cloud/cloud_api";
import ZkTextArea from "../../../cloud/common/zkTextArea/zkTextArea";
import {Link} from "react-router-dom";
import {Path} from "../../../public/path";
import Message from "../../../common/message";

/**
 * data: 登录的账号信息， 头图，昵称等等
 * wxid： 登录的 id
 * onlyCode: 仅扫码登录 boolean，默认false
 * afterSuccess 登录成功的回调
 * @type {null}
 */
let timer = null

class ImLogin extends Component {

    state = {
        //企微登录
        status: 10,
        qrcodeUrl: '',
        loginQrcodeKey: '',
        key: '',
        name: '',
        corpName: '',
        avatar: '',
        loginException: '',
        pid: 0,
        scanInfo: {
            avatorUrl: '',
            corpLogo: '',
            loginStatus: 0,
            nickname: '',
            clientId: 0
        },
        loginVerifyCode: '',
        loginVerifyBtnLoading: false
    }
    //企微登录
    wxLogin = () => {
        const {wxid, afterSuccess, onlyCode} = this.props
        clearTimeout(timer)
        this.wxLoginModal.show()
        this.isLoop = true
        CloudApi.chatWxLogin(wxid, data => {
            this.setState({
                status: data.status,
                qrcodeUrl: data.qrcodeUrl,
                loginQrcodeKey: data.loginQrcodeKey,
                key: data.key,
                pid: data.pid
            })
            //0：无席位
            // 1：自动登录中
            // 2：需要扫码登录
            // 3：扫码中
            // 4：登录成功
            // 5：登录过期
            // 6：登陆失败
            if (data.status == 0) {
                this.wxLoginModal.hide()
                this.noSeatModal.show()
            } else if (data.status == 4) {
                if (afterSuccess) {
                    afterSuccess()
                }
            } else if (data.status == 5) {
                clearTimeout(timer)
                this.isLoop = false
            } else {
                if (data.loginQrcodeKey) {
                    this.getLoginScanResult(data.loginQrcodeKey)
                } else {
                    this.getLoginStatus()
                }
            }
        })
    }

    loginVerify = () => {
        let loginVerifyCode = this.state.loginVerifyCode
        if (loginVerifyCode != '' && loginVerifyCode.length > 0) {
            let loginQrcodeKey = this.state.loginQrcodeKey
            let clientId = this.state.scanInfo.clientId
            let pid = this.state.pid
            this.setState({
                loginVerifyBtnLoading: true
            })
            CloudApi.loginVerify({
                loginQrcodeKey: loginQrcodeKey,
                loginVerifyCode: loginVerifyCode,
                clientId: clientId,
                pid: pid
            }, () => {
                this.getLoginStatus()
            }, (err) => {
                if (err.respCode == -1) {
                    let errmsg = err.respMsg
                    if (errmsg && errmsg.errorDesc) {
                        Message.error(errmsg.errorDesc)
                    } else {
                        Message.error("登录失败")
                    }
                }
                this.setState({
                    loginVerifyBtnLoading: false
                })
            })
        } else {
            Message.warning("请输入手机上的验证码以登录")
        }
    }

    getLoginScanResult = (loginQrcodeKey, loginStatus = 0, count = 1) => {
        if (!this.isLoop) {
            clearTimeout(timer)
            return;
        }
        if (loginStatus == 1 && count > 5) {
            this.getLoginStatus()
            return
        }
        let key = this.state.key
        CloudApi.loginScanResult(loginQrcodeKey, key, (data) => {
            if (data) {
                if (data.loginStatus == 1 || data.loginStatus == 2) {
                    if (count == 1) {
                        //首次
                        setTimeout(() => {
                            this.getLoginScanResult(loginQrcodeKey, 1, count + 1)
                        }, 1000)
                    } else {
                        this.getLoginStatus()
                    }
                } else {
                    this.setState({
                        status: 10,
                        scanInfo: data,
                        loginVerifyBtnLoading: false
                    })
                }
            }
        }, () => {
            setTimeout(() => {
                if (loginStatus == 1) {
                    count = count + 1
                }
                this.getLoginScanResult(loginQrcodeKey, loginStatus, count)
            }, 1000)
        })
    }

    //轮询登录状态
    getLoginStatus = () => {
        if (!this.isLoop) {
            clearTimeout(timer)
            return;
        }
        const {wxid, afterSuccess, onlyCode} = this.props
        const {status, key} = this.state
        /**
         * 1 登陆成功，结束轮询, 中断该方法
         * 2 登陆失败，关闭登录modal， 打开重新登录modal， 中断该方法
         * 3 正常轮询
         */
        if (status == 4) {
            clearTimeout(timer)
            if (afterSuccess) {
                afterSuccess()
            }
            return
        } else if (status == 6) {
            this.wxLoginModal.hide()
            this.wxReLoginModal.show()
            return
        } else if (status == 7) {
            this.wxLoginModal.hide()
            this.wxLoginErrorModal.show()
            return
        } else if (status == 0) {
            this.wxLoginModal.hide()
            this.noSeatModal.show()
            return
        } else {
            CloudApi.chatLoginStatus(key, data => {
                if (this.state.status != 10) {
                    if (data.status == 2) {
                        this.setState({
                            qrcodeUrl: data.qrcodeUrl,
                            status: data.status,
                            loginQrcodeKey: data.loginQrcodeKey,
                            pid: data.pid
                        })
                        if (data.loginQrcodeKey) {
                            this.getLoginScanResult(data.loginQrcodeKey)
                            return;
                        }
                    }
                }
                if (data.status == 6) {
                    this.setState({
                        corpName: data.corpName,
                        status: data.status
                    })
                    this.wxLoginModal.hide()
                    this.wxReLoginModal.show()
                } else if (data.status == 7) {
                    this.setState({
                        loginException: data.errormsg || '登录异常，请重新登录或联系客服',
                        status: data.status
                    })
                    this.wxLoginModal.hide()
                    this.wxLoginErrorModal.show()
                } else if (status == 0) {
                    this.wxLoginModal.hide()
                    this.noSeatModal.show()
                } else if (data.status == 4) {
                    this.setState({
                        name: data.name,
                        corpName: data.corpName,
                        avatar: data.avatar,
                        status: data.status
                    })
                    clearTimeout(timer)
                    if (afterSuccess) {
                        afterSuccess()
                    }
                } else {
                    timer = setTimeout(this.getLoginStatus, 1000)
                }
            }, error => {
                timer = setTimeout(this.getLoginStatus, 1000)
            })
        }
    }

    //login afterClose
    loginClose = () => {
        this.isLoop = false
        clearTimeout(timer)
        this.setState({
            status: -1,
            qrcodeUrl: '',
        })
    }

    //重新登录
    reLogin = () => {
        this.wxReLoginModal.hide()
        this.wxLoginErrorModal.hide()
        this.wxLogin()
    }

    //开始使用
    toUse = () => {
        this.wxLoginModal.hide()
    }

    render() {
        const {status, qrcodeUrl, name, corpName, avatar, loginException, scanInfo} = this.state
        const {data, onlyCode} = this.props
        return (
            <>
                {/*{企微登录modal}*/}
                <ZkModal title={'企业微信登录'} ref={r => this.wxLoginModal = r} width={520} footer={null}
                         maskClosable={false}
                         afterClose={() => {
                             this.loginClose()
                         }}>
                    {
                        onlyCode ? <ZkTextArea type={'yellow'}
                                               value={'企微助手Pro和电脑版企业微信无法同时登录，登录电脑版企业微信或者切换企业会导致企微助手Pro账号离线。'}/> : ''
                    }
                    <div className={'seat_wxlogin_content'}>
                        {/*//0：无席位*/}
                        {/*// 1：自动登录中*/}
                        {/*// 2：需要扫码登录*/}
                        {/*// 3：扫码中*/}
                        {/*// 4：登录成功*/}
                        {/*// 5：登录过期*/}
                        {
                            status == 0 ?
                                <>
                                    <div className={'seat_rePay_info'}>
                                        <img src={data.avatar} className={'seat_rePay_info_img'}/>
                                        <div className={'seat_rePay_info_right'}>
                                            <div className={'im-wx-name'}>{data.nickname}</div>
                                            <div className={'im-wx-corpName'}>{data.shortCorpName}</div>
                                        </div>
                                    </div>
                                </>
                                :
                                status == 1 ?
                                    <>
                                        <div className={'seat_rePay_info'}>
                                            <img src={data.avatar} className={'seat_rePay_info_img'}/>
                                            <div className={'seat_rePay_info_right'}>
                                                <div className={'im-wx-name'}>{data.nickname}</div>
                                                <div className={'im-wx-corpName'}>{data.shortCorpName}</div>
                                            </div>
                                        </div>
                                        <div className={'login-ing'}>{'账号登录中...'}</div>
                                    </>
                                    :
                                    status == 3 || status == 2 || status == 5 ?
                                        <>
                                            {
                                                status == 5 ?
                                                    <div className={'im-bold-font'}>{'登录过期，请重新扫码登录'}</div> : ''
                                            }
                                            <div className={'seat_wxlogin_code'}>
                                                <div className={'code_mask'}
                                                     style={{display: status == 5 ? '' : 'none'}}
                                                     onClick={this.wxLogin}>
                                                    <div style={{textAlign: 'center'}}>
                                                        <RedoOutlined/>
                                                        <div>{'二维码失效，点击刷新'}</div>
                                                    </div>
                                                </div>
                                                <img
                                                    src={qrcodeUrl || ''}
                                                    style={{height: '100%'}}/>
                                            </div>


                                            {
                                                status == 5 ?
                                                    <p className={'im-login-bottom'}>二维码已过期，刷新之后重新扫码登录
                                                        &nbsp;<span className={'login_refresh'}
                                                                    onClick={this.wxLogin}>刷新</span>
                                                    </p>
                                                    : ''
                                            }
                                            {
                                                onlyCode ? '' :
                                                    <div className={'seat_rePay_info'}>
                                                        <img src={data.avatar} className={'seat_rePay_info_img'}/>
                                                        <div className={'seat_rePay_info_right'}>
                                                            <div className={'im-wx-name'}>{data.nickname}</div>
                                                            <div className={'im-wx-corpName'}>{data.shortCorpName}</div>
                                                        </div>
                                                    </div>
                                            }

                                            <p className={'im-login-bottom'} style={{marginTop: '14px'}}>
                                                {'请使用企业微信扫码登录'}
                                            </p>
                                        </>
                                        :
                                        status == 4 ?
                                            <>
                                                <div className={'seat_rePay_info'} style={{margin: '30px 0'}}>
                                                    <img src={avatar || data.avatar} className={'seat_rePay_info_img'}/>
                                                    <div className={'seat_rePay_info_right'}>
                                                        <div className={'im-wx-name'}>{name || data.nickname}</div>
                                                        <div
                                                            className={'im-wx-corpName'}>{corpName || data.shortCorpName}</div>
                                                    </div>
                                                </div>
                                                <Button type="primary" onClick={this.toUse}>
                                                    登录成功，开始使用
                                                </Button>
                                            </>
                                            : status == 10 && scanInfo.loginStatus == 10 ?
                                            <div>
                                                <div className={'scanWrapper'}>
                                                    <img className={'scanCorpLogo'} src={scanInfo.corpLogo}/>
                                                    <img className={'scanAvator'} src={scanInfo.avatorUrl}/>
                                                    <span className={'scanNickname'}>{scanInfo.nickname}</span>
                                                </div>
                                                <div className={'loginVerifyWrapper'}>
                                                    <span className={'loginVerifyTip'}>请输入手机上的验证码以登录</span>
                                                    <Input value={this.state.loginVerifyCode} onChange={(e) => {
                                                        this.setState({
                                                            loginVerifyCode: e.target.value
                                                        })
                                                    }}/>
                                                    <Button className={'loginVerifyBtn'} type={'primary'}
                                                            loading={this.state.loginVerifyBtnLoading}
                                                            onClick={this.loginVerify}>登录</Button>
                                                </div>
                                            </div> : <></>
                        }
                    </div>
                </ZkModal>

                {/*{企微重新登录modal}*/}
                <ZkModal title={'提示'} ref={r => this.wxReLoginModal = r} width={480}
                         afterClose={null}
                         footer={[
                             <Button key="back" onClick={() => this.wxReLoginModal.hide()}>
                                 取消登录
                             </Button>,
                             <Button key="submit" type="primary" onClick={this.reLogin}>
                                 重新登录
                             </Button>,
                         ]}>
                    <div className={'wx_reLogin'}>
                        <img src={imWarning} style={{height: '40px'}}/>
                        <p className={'wx_LoginFail_desc'}>{'企业微信登录失败'}</p>
                        <div className={'wx_ReloginWarning_desc'}>
                            {`该席位归属于${corpName}，只能是${corpName}下的企业微信账号才能登录`}
                        </div>
                    </div>
                </ZkModal>

                {/*{企微登录异常modal}*/}
                <ZkModal title={'提示'} ref={r => this.wxLoginErrorModal = r} width={480}
                         afterClose={null}
                         footer={[
                             <Button key="back" onClick={() => this.wxLoginErrorModal.hide()}>
                                 取消登录
                             </Button>,
                             <Button key="submit" type="primary" onClick={this.reLogin}>
                                 重新登录
                             </Button>,
                         ]}>
                    <div className={'wx_reLogin'}>
                        <img src={imWarning} style={{height: '40px'}}/>
                        <p className={'wx_LoginFail_desc'}>{'企业微信登录失败'}</p>
                        <div className={'wx_ReloginWarning_desc'}>
                            {loginException}
                        </div>
                    </div>
                </ZkModal>

                {/*{席位不足modal}*/}
                <ZkModal title={'提示'} ref={r => this.noSeatModal = r} width={480}
                         afterClose={null}
                         footer={[
                             <Button key="back" onClick={() => this.noSeatModal.hide()}>
                                 我再想想
                             </Button>,
                             <Link to={{
                                 pathname: Path.getMineOrderProductRenewal(),
                                 state: {product: 'assistantPro'}
                             }}>
                                 <Button key="submit" type="primary" style={{marginLeft: '10px'}}>
                                     购买席位
                                 </Button>
                             </Link>,
                         ]}>
                    <div className={'wx_reLogin'}>
                        <img src={imWarning} style={{height: '40px'}}/>
                        <p className={'im-bold-font'}>{'席位不足'}</p>
                        <div className={'wx_ReloginWarning_desc'}>
                            {`当前席位不足，请购买席位之后重新登录`}
                        </div>
                    </div>
                </ZkModal>
            </>
        );
    }

}

export default ImLogin;